import { useHttpClient } from '@/common/api/httpClient';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import type { ProductionOrder } from 'shared/productionOrders/domain/productionOrder';

export interface ListProductionOrderResponse {
  ok: true;
  productionOrders: ProductionOrder[];
}

export function useListProductionOrders() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('productionorder'), {
      headers,
    });

    const text = translations.value.productionOrders.actions.fetchMany;

    const response = await httpClient.action<ListProductionOrderResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = (await response.json()) as ProductionOrder[];
        return {
          ok: true,
          productionOrders: json,
        };
      },
    });

    return response;
  }
}
